import { create } from 'zustand';
import { Moment } from 'moment';

import { ESortOrder, EStatusStr, MappedEventVersion } from '@src/emp-3.0/types';
import { EPanelOpenMethod } from '@components/block-event-single/store';
import { createSetState, removeInvalidSelectedList } from '@src/emp-3.0/utils/management';
import { DEFAULT_SELECT_VALUE } from '@src/emp-3.0/constants/management';
import { IFrontendGeneratedFields } from '@src/emp-3.0/components/Management';

interface ISelectMappedEvent extends MappedEventVersion, IFrontendGeneratedFields {}

interface IUseMappedEventManagementStoreProps {
  openBulkAction: boolean;
  setOpenBulkAction: (openBulkAction: boolean) => void;
  operationMode: EPanelOpenMethod;
  setOperationMode: (operationMode: EPanelOpenMethod) => void;
  activeEvent: ISelectMappedEvent | undefined;
  setActiveEvent: (activeEvent: ISelectMappedEvent | undefined) => void;

  // multiple selection operation
  selectedList: ISelectMappedEvent[];
  setSelectedList: (selectedList: ISelectMappedEvent[]) => void;
  setRemoveInvalidSelectedList: (allSelectedList: ISelectMappedEvent[]) => void;

  // search
  searchText: string;
  setSearchText: (searchText: string) => void;

  // sort
  sort: { key: string; order: number };
  setSort: (sort: { key: string; order: number }) => void;

  // filter condition
  showFilter: boolean;
  setShowFilter: (showFilter: boolean) => void;
  status: EStatusStr;
  setStatus: (status: EStatusStr) => void;
  category: string;
  setCategory: (category: string) => void;
  updateDate: Moment[];
  setUpdateDate: (updateDate: Moment[]) => void;
  deployDate: Moment[];
  setDeployDate: (deployDate: Moment[]) => void;
  createdBy: string;
  setCreatedBy: (updatedBy: string) => void;
  updatedBy: string;
  setUpdatedBy: (updatedBy: string) => void;

  // reset
  resetFilter: () => void;
  resetStore: () => void;
}

export const useMappedEventManagementStore = create<IUseMappedEventManagementStoreProps>((set) => ({
  openBulkAction: false,
  operationMode: EPanelOpenMethod.VIEW,
  activeEvent: undefined,

  setOpenBulkAction: createSetState(set, 'openBulkAction'),
  setOperationMode: createSetState(set, 'operationMode'),
  setActiveEvent: createSetState(set, 'activeEvent'),

  // multiple selection operation
  selectedList: [],
  setSelectedList: createSetState(set, 'selectedList'),
  setRemoveInvalidSelectedList: removeInvalidSelectedList(set),

  // sort
  searchText: '',
  setSearchText: createSetState(set, 'searchText'),

  // sort
  sort: { key: '', order: ESortOrder.NORMAL },
  setSort: createSetState(set, 'sort'),

  // filter condition
  showFilter: false,
  status: EStatusStr.ALL,
  category: DEFAULT_SELECT_VALUE,
  updateDate: [],
  deployDate: [],
  createdBy: DEFAULT_SELECT_VALUE,
  updatedBy: DEFAULT_SELECT_VALUE,

  setShowFilter: createSetState(set, 'showFilter'),
  setStatus: createSetState(set, 'status'),
  setCategory: createSetState(set, 'category'),
  setUpdateDate: createSetState(set, 'updateDate'),
  setDeployDate: createSetState(set, 'deployDate'),
  setCreatedBy: createSetState(set, 'createdBy'),
  setUpdatedBy: createSetState(set, 'updatedBy'),

  // reset
  resetFilter: () =>
    set(() => ({
      status: EStatusStr.ALL,
      category: DEFAULT_SELECT_VALUE,
      updateDate: [],
      deployDate: [],
      createdBy: DEFAULT_SELECT_VALUE,
      updatedBy: DEFAULT_SELECT_VALUE,
    })),

  resetStore: () =>
    set(() => ({
      activeEvent: undefined,
      selectedList: [],
      searchText: '',
      sort: { key: '', order: ESortOrder.NORMAL },
      showFilter: false,
      status: EStatusStr.ALL,
      category: DEFAULT_SELECT_VALUE,
      updateDate: [],
      deployDate: [],
      createdBy: DEFAULT_SELECT_VALUE,
      updatedBy: DEFAULT_SELECT_VALUE,
    })),
}));
